"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfiniteLoader_1 = require("./InfiniteLoader");
exports.default = InfiniteLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InfiniteLoader/index.js
// module id = 1699
// module chunks = 8